// IMPORT REACT
import React from 'react';

// IMPORT COMPONENTS
import YAContainer from '../../components/Grid/Container';
import YASection from '../../components/Grid/Section';
import YANavbar from '../Navbar/';

// IMPORT STYLES
import { SC_CircleDecor  } from './styles';


const YAHeader = (props) => {
    return (
    	<YASection background="primary" color="white" angle="bottom" padding={{'top': '0', 'bottom': '3rem'}} hasContent={props.children ? true : null} pageTemplate={props.page ? props.page.post_name_en : null}>
    		{props.lang && props.page ? <SC_CircleDecor width={450}/> : null}
			{props.lang && props.page ? <YANavbar {...props}></YANavbar> : null}
    		<YAContainer textAlign="center">
          
    			{props.children ? props.children : null}
          
    		</YAContainer>
      </YASection>
    )
    
}
export default YAHeader;